import { render, staticRenderFns } from "./ManageSubCategoriesLayout.vue?vue&type=template&id=297e8381&scoped=true"
import script from "./ManageSubCategoriesLayout.vue?vue&type=script&lang=js"
export * from "./ManageSubCategoriesLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297e8381",
  null
  
)

export default component.exports